import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import messages from "./Welcome/module/messages";
import { ROUTES } from "../../module/constants";
import {
  MdMail,
  MdMenuBook,
  MdMobileFriendly,
  MdNotes,
  MdOutlineAddTask,
  MdOutlineAnalytics,
  MdOutlineFactCheck,
  MdOutlineLibraryBooks,
  MdOutlineManageSearch,
  MdOutlinePersonAddAlt,
  MdOutlinePersonSearch,
  MdOutlinePostAdd,
  MdOutlineSettings,
  MdTableChart,
  MdWork,
  MdWysiwyg,
} from "react-icons/md";
import { UserSections } from "../../models/User";
import {
  FaBell,
  FaClock,
  FaFileCsv,
  FaQuestion,
  FaRegEdit,
  FaUnlockAlt,
  FaUser,
} from "react-icons/fa";
import { RiRobotLine } from "react-icons/ri";

interface DashboardRouteCard {
  sectionCode: UserSections;
  title: ReactNode;
  description: ReactNode | string;
  icon: ReactNode;
  url: string;
}

export const CONSOLE_ADMIN_DASHBOARD_CARDS: DashboardRouteCard[] = [
  {
    title: <FormattedMessage {...messages.usersManagement} />,
    description: "",
    url: ROUTES.ADMIN_USERS_MGMT,
    icon: <MdOutlinePersonSearch />,
    sectionCode: UserSections.ADM_USER_MGMT,
  },
  {
    title: (
      <FormattedMessage {...messages.applicationsAbilitationsManagement} />
    ),
    description: "",
    url: ROUTES.ADMIN_APPLICATIONS_ABILITATIONS_MGMT,
    icon: <MdOutlineManageSearch />,
    sectionCode: UserSections.ADM_APP_ENT_MGMT,
  },
  {
    title: <FormattedMessage {...messages.adminBRManagement} />,
    description: "",
    url: ROUTES.ADMIN_BR_MGMT,
    icon: <MdOutlinePersonAddAlt />,
    sectionCode: UserSections.ADM_BR_MGMT,
  },
  {
    title: <FormattedMessage {...messages.catalogManagement} />,
    description: "",
    url: ROUTES.ADMIN_CATALOG_MGMT,
    icon: <MdOutlineLibraryBooks />,
    sectionCode: UserSections.ADM_CATALOG_MGMT,
  },
  {
    title: <FormattedMessage {...messages.passwordManagement} />,
    description: "",
    url: ROUTES.ADMIN_PWD_MGMT,
    icon: <FaUnlockAlt />,
    sectionCode: UserSections.ADM_PWD_MGMT,
  },
  {
    title: <FormattedMessage {...messages.externalPortalManagement} />,
    description: "",
    url: ROUTES.ADMIN_EXTERNAL_PORTAL_MGMT,
    icon: <MdWysiwyg />,
    sectionCode: UserSections.ADM_EXTERNAL_PORTAL_MGMT,
  },
  {
    title: <FormattedMessage {...messages.SODManagement} />,
    description: "",
    url: ROUTES.ADMIN_SOD_MGMT,
    icon: <MdOutlinePostAdd />,
    sectionCode: UserSections.ADM_SOD_MGMT,
  },
  {
    title: <FormattedMessage {...messages.serviceRequestManagement} />,
    description: "",
    url: ROUTES.ADMIN_SERVICE_REQUEST_MGMT,
    icon: <FaQuestion />,
    sectionCode: UserSections.ADM_SERVICE_REQ_MGMT,
  },
  {
    title: <FormattedMessage {...messages.manualsManagement} />,
    description: "",
    url: ROUTES.ADMIN_MANUALS_MGMT,
    icon: <MdMenuBook />,
    sectionCode: UserSections.ADM_MANUALS_MGMT,
  },
  {
    title: <FormattedMessage {...messages.reportManagement} />,
    description: "",
    url: ROUTES.ADMIN_REPORT_MGMT,
    icon: <MdNotes />,
    sectionCode: UserSections.ADM_REPORT_MGMT,
  },
  {
    title: <FormattedMessage {...messages.templateMailManagement} />,
    description: "",
    url: ROUTES.ADMIN_TEMPLATE_MAIL_MGMT,
    icon: <MdMail />,
    sectionCode: UserSections.ADM_TEMPLATE_MGMT,
  },
  {
    title: <FormattedMessage {...messages.templateSmsManagement} />,
    description: "",
    url: ROUTES.ADMIN_TEMPLATE_SMS_MGMT,
    icon: <MdMobileFriendly />,
    sectionCode: UserSections.ADM_SMS_TEMPLATE_MGMT,
  },
  {
    title: <FormattedMessage {...messages.workflowManagement} />,
    description: "",
    url: ROUTES.ADMIN_WORKFLOW_MGMT,
    icon: <MdWork />,
    sectionCode: UserSections.ADM_WORKFLOW_MGMT,
  },
  {
    title: <FormattedMessage {...messages.tablesConfigurationManagement} />,
    description: "",
    url: ROUTES.ADMIN_TABLES_CONFIGURATION_MGMT,
    icon: <MdTableChart />,
    sectionCode: UserSections.ADM_TABLE_CONFIG_MGMT,
  },
  {
    title: <FormattedMessage {...messages.recoveryPointManagement} />,
    description: "",
    url: ROUTES.ADMIN_RECOVERY_POINT_MGMT,
    icon: <MdOutlineFactCheck />,
    sectionCode: UserSections.ADM_RECOVERY_MGMT,
  },
  {
    title: <FormattedMessage {...messages.profilesManagement} />,
    description: "",
    url: ROUTES.ADMIN_PROFILES_MGMT,
    icon: <FaUser />,
    sectionCode: UserSections.ADM_PROFILES_MGMT,
  },
  {
    title: <FormattedMessage {...messages.auditManagement} />,
    description: "",
    url: ROUTES.ADMIN_AUDIT_MGMT,
    icon: <MdOutlineAnalytics />,
    sectionCode: UserSections.ADM_AUDIT_MGMT,
  },
  {
    title: <FormattedMessage {...messages.notifyAdmin} />,
    description: "",
    url: ROUTES.ADMIN_NOTIFY_MGMT,
    icon: <FaBell />,
    sectionCode: UserSections.ADM_NOTIFY_MGMT,
  },
  {
    title: <FormattedMessage {...messages.temporaryAbilitationsManagement} />,
    description: "",
    url: ROUTES.ADMIN_TEMPORARY_ABILITATIONS_MGMT,
    icon: <FaClock />,
    sectionCode: UserSections.ADM_TEMPORARY_ABILITATIONS_MGMT,
  },
  {
    title: (
      <FormattedMessage {...messages.certificationConfigurationsManagement} />
    ),
    description: "",
    url: ROUTES.ADMIN_CERTIFICATION_CONFIGURATIONS_MGMT,
    icon: <FaRegEdit />,
    sectionCode: UserSections.ADM_RECERTIFICATION_CONFIGURATION,
  },
  {
    title: <FormattedMessage {...messages.createCertification} />,
    description: "",
    url: ROUTES.CREATE_CERTIFICATION,
    icon: <MdOutlineAddTask />,
    sectionCode: UserSections.CREATE_CAMPAIGN,
  },
  {
    title: <FormattedMessage {...messages.csvManagement} />,
    description: "",
    url: ROUTES.ADMIN_CSV_UPLOADER,
    icon: <FaFileCsv />,
    sectionCode: UserSections.ADM_UIGP_MGMT,
  },
  {
    title: <FormattedMessage {...messages.technicalUsersManagement} />,
    description: "",
    url: ROUTES.ADMIN_TECHNICAL_USERS_MGMT,
    icon: <RiRobotLine />,
    sectionCode: UserSections.ADM_TECHNICAL_USERS_MGMT,
  },
  {
    title: <FormattedMessage {...messages.uigpManagement} />,
    description: "",
    url: ROUTES.ADMIN_UIGP_MGMT,
    icon: <MdOutlineSettings />,
    sectionCode: UserSections.ADM_UIGP_MGMT,
  },
];
